import { FC, createContext, useContext } from 'react';

import { DialogImportCustomersFromCSVProps } from './types';

const DialogImportCustomersFromCSVContext =
  createContext<DialogImportCustomersFromCSVProps>({
    open: false,
    onClose: () => {},
    onSubmitSuccess: () => {},
    onUpdateErrors: undefined,
  });

export const useDialogImportCustomersFromCSVContext =
  (): DialogImportCustomersFromCSVProps =>
    useContext(DialogImportCustomersFromCSVContext);

const DialogImportCustomersFromCSVProvider: FC<
  DialogImportCustomersFromCSVProps
> = ({ open, onClose, onSubmitSuccess, onUpdateErrors, children }) => (
  <DialogImportCustomersFromCSVContext.Provider
    value={{
      open,
      onClose,
      onSubmitSuccess,
      onUpdateErrors,
    }}
  >
    {children}
  </DialogImportCustomersFromCSVContext.Provider>
);

export default DialogImportCustomersFromCSVProvider;
